var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.icon, _vm.color, _vm.size, {'fa-spin': _vm.spin}, {'fa-pulse': _vm.pulse}],attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6e1b25","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icons/Icon.vue
// module id = 619
// module chunks = 52